import { call, put, select, takeLatest } from 'redux-saga/effects'
import { IOptionsResponse } from '../../../common/common.types'
import { throwPcrException } from '../../../features/pcr/store/pcr.actions'
import { ClientDataConstants } from '../../../features/clientData/store/clientData.constants'
import { getServiceIdSelector } from '../../../features/user/selectors'
import { ProcedureService } from '../services/procedure.service'
import { setResponseValueOptions } from '../store/procedure.actions'

export function* getResponseOptions() {
  const serviceId: string = yield select(getServiceIdSelector)
  const procedureService = new ProcedureService(serviceId)
  try {
    const response: IOptionsResponse = yield call([procedureService, procedureService.getResponseOptions])
    const { entity } = response
    yield put(setResponseValueOptions(entity))
  } catch (e) {
    yield put(throwPcrException(`getResponseOptions() error: ${e}`))
  }
}

export function* getResponseOptionsSaga() {
  yield takeLatest([ClientDataConstants.ON_CLIENT_DATA_IMPORT_SUCCESS], getResponseOptions)
}
